import { CONFIGURATION_DEVICES_PATH } from 'installations/navigation';

module.exports = {
  path: CONFIGURATION_DEVICES_PATH,
  getChildRoutes(partialNextState, cb) {
    require.ensure([], (require) => {
      cb(null, [
        require('./routes/add'),
        require('./routes/show'),
      ]);
    });
  },
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/InstallationDevices'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/installations/routes/show/routes/configuration/routes/devices/index.js